export default "__VITE_ASSET__BcnR6hhq__"